import { Vector3, AnimationMixer } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { Instrument } from "./instrument";
import { instrumentsInfo2 } from "../../constant";
import { isMobile } from "react-device-detect";

const setting = {
  position: new Vector3(-5, -1, 7),
  scale: isMobile ? new Vector3(5, 5, 5) : new Vector3(8, 8, 8),
};

class Instrument2 extends Instrument {
  constructor() {
    super(2, ["instrument5", "instrument6", "instrument8", "instrument9"]);
    this.instrumentsInfo = instrumentsInfo2;
  }
  load(scene) {
    const loader = new GLTFLoader();
    loader.load(`/models/instruments/instrument${this.id}.glb`, (gltf) => {
      this.gltf = gltf;
      this.gltf.scene.traverse((child) => {
        if (child.name === "Button_range") {
          child.visible = false;
        }
        if (child.name === "boby_1") {
          this.body = child;
        }
      });
      this.gltf.scene.name = `Instrument_model${this.id}`;
      this.gltf.scene.scale.copy(setting.scale);
      this.animationMixer = new AnimationMixer(this.body);
      this.animations = this.gltf.animations[0];
      this.objects = this.gltf.scene.children[2].children;
      this.setAxisCenter(this.box, this.gltf.scene);

      scene.add(this.gltf.scene);
    });
  }
  click() {
    if (!this.gltf) return;
    const intersects = this.raycaster.intersectObjects(this.objects, true);
    if (intersects.length) {
      const name = intersects[0].object.name;
      if (this.instrumentsInfo[name]) {
        this.target = name;
        this.target === "05" && this.playAnimation();
        this.playSound();
      }
    }
  }
  hover() {
    if (!this.gltf) return;
    const intersects = this.raycaster.intersectObjects(this.objects, true);
    if (intersects.length) {
      const name = intersects[0].object.name;
      if (this.instrumentsInfo[name]) {
        document.body.style.cursor = "pointer";
      } else {
        document.body.style.cursor = "auto";
      }
    }
  }
  playAnimation() {
    this.animationMixer = new AnimationMixer(this.body);
    this.animationAction = this.animationMixer.clipAction(this.animations);
    this.animationAction.play();
  }
  stop() {
    if (this.animationAction) {
      this.stopAnimation();
    }
    this.stopSound();
    this.target = null;
  }
}

export default Instrument2;
